import { CheckboxSelector, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import React, { useMemo } from 'react'
import { Badge } from 'reactstrap'
import useTranslation from '../../../i18n/useTranslation'
import FilterBadge from '../../../common/FilterBadge'

const StatusesFilter = (props) => {
  const { translate } = useTranslation()
  const { statuses, statusFilters, setStatusFilters, useInner = false } = props
  const pillColor = (item) => {
    let statusClass
    switch (item) {
      case 'canceled':
        statusClass = '#000'
        break
      case 'pendingPayment':
        statusClass = 'error'
        break
      case 'unpaid':
        statusClass = 'warning'
        break
      case 'paid':
        statusClass = '#9BE313'
        break
      case 'refunded':
        statusClass = 'success'
        break
      default:
        statusClass = 'primary'
    }
    return statusClass
  }
  const selectorData = useMemo(() => statuses.map((item) => ({
    name: translate(`invoices.status.${item}`),
    id: item,
    Component: (
      <Badge
        color={pillColor(item)}
        style={{
          width: 8,
          height: 8,
          minHeight: 8,
          padding: 0,
          marginRight: 8,
          border: 'none',
          lineHeight: 0,
          flexShrink: 0,
          ...(pillColor(item).includes('#') ? { backgroundColor: pillColor(item) } : {})
        }}
        pill
        className='point'
      >
        &nbsp;
      </Badge>
    )
  })), [statuses, translate])
  
  const checkboxSelectorProps = {
    setDataFilters: setStatusFilters,
    direction: 'bottom',
    dataFilters: statusFilters,
    typeFilter: 'statuses',
    data: selectorData,
    strings: {
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    }
  }

  return (
    useInner ?
    <CheckboxSelectorInner style={{maxWidth: 'auto'}} {...checkboxSelectorProps} /> :
    <CheckboxSelector {...checkboxSelectorProps}>
      <FilterBadge
        title={translate('filters.plans.status.title')}
        options={selectorData}
        selectedIds={statusFilters}
        showOptionComponents
        onClearFilters={() => setStatusFilters([])}
      />
    </CheckboxSelector>
  )
}
export default StatusesFilter
